module.exports = __webpack_public_path__ + "static/media/Mister_Gee_burgers.f2e8701b.png";